/** 首页 Banner 跳转类型（与后端 link_type 对齐） */
export enum HomeBannerLinkType {
  None = 'none',
  Game = 'game',
  /** link_target 为页面编码 page_code，走 useNoticePageNav.openPage */
  InternalPage = 'internal_page',
  Promotion = 'promotion',
  /** link_target 为公告 id，拼成 a_{id} 后打开消息详情抽屉 */
  Announcement = 'announcement',
  Url = 'url',
}

/** 首页轮播单张卡片的数据结构 */
export interface HomeBannerItem {
  id: string
  tag: string // 左上角小标签，如「体育博彩」
  title: string // 主标题
  subtitle?: string // 副标题，可选
  ctaText: string // 底部按钮文案，如「立即投注」
  image: string // 背景图地址
  /** 背景图 BCA1 key；非空时 image 为密文容器 */
  imageKey?: string
  linkType?: HomeBannerLinkType
  linkTarget?: string
}

const BANNER_LINK_TYPES = new Set<string>(Object.values(HomeBannerLinkType))

/** 后端 link_type 字符串 → 枚举；未知值返回 undefined */
export function normalizeBannerLinkType(value?: string): HomeBannerLinkType | undefined {
  if (!value || !BANNER_LINK_TYPES.has(value)) return undefined
  return value as HomeBannerLinkType
}
